import * as React from 'react'
import { withIdentity, IdentityProps } from "../services/authentication"
import { Avatar, Dropdown, Menu, Icon, Badge } from 'antd'
let MenuItem = Menu.Item
import { withTranslation, WithTranslation } from 'react-i18next'
import Link from 'src/core/ui/link'
import { isNullOrWhitespace } from 'src/core/utils/object'
import { getGravatar } from 'src/core/utils/gravatar'
import { resolve } from 'src/inversify.config'
import { PreferencesService } from 'src/core/services/preferences.service'
import { ClickParam } from 'antd/lib/menu'
import { NavItem } from './shell-header'
import ProfileView from './profile-ui'
interface LoginBoxProps extends IdentityProps, WithTranslation {
  ensureCompanySelection?: boolean
  isMobileOrTablet?: boolean
}

interface LoginBoxState {
  currentCompanyId: string | undefined,
  currentCompanyTitle: string | undefined
  showProfile: boolean
}

class LoginBox extends React.Component<LoginBoxProps, LoginBoxState> {
  @resolve(PreferencesService)
  private readonly preferencesService!: PreferencesService

  constructor(props: LoginBoxProps) {
    super(props)
    this.state = {
      currentCompanyId: undefined,
      currentCompanyTitle: undefined,
      showProfile: false
    }
    this.handleClick = this.handleClick.bind(this)
  }

  componentWillMount() {
    //if (this.preferencesService) {
    //    this.preferencesService.current().then(prefs => {
    //        if (this.props.ensureCompanySelection && (!prefs || !prefs.currentCompanyId)) {
    //            window.location.href = '/home/companies/select';
    //            return;
    //        }
    //        this.setState({ currentCompanyId: prefs.currentCompanyId, currentCompanyTitle: prefs.currentCompanyTitle });
    //    }).catch(error => {
    //        if (this.props.ensureCompanySelection) {
    //            window.location.href = '/home/companies/select';
    //        }
    //    });
    //}
  }

  private handleClick(key: ClickParam) {
    if (key.key == 'logout') {
      this.props.identity.logout()
    }
  }

  public render() {
    const { t } = this.props
    if (!this.props.identity) {
      return <Link to='/identity/account/login'>{t("Login")}</Link>
    }
    var displayName = `${this.props.identity.firstName || ''} ${this.props.identity.lastName || ''}`
    if (isNullOrWhitespace(displayName)) {
      displayName = this.props.identity.profile.name
    }
    var avatarSrc = getGravatar(this.props.identity.email || "gravatar@tempuri.org", 32)
    
      return <>

        <NavItem key={'loginBox'}
          icon={<Badge dot={false}><div onClick={() => this.setState({ showProfile: true })}><Avatar style={{ border: "solid 4px lightgray" }} icon={<Icon type="user" />} size={40} shape="circle" src={avatarSrc} /></div> </Badge>}
          title={"  "}
        >

        </NavItem>
        {this.state.showProfile && <ProfileView onClose={() => this.setState({ showProfile: false })}></ProfileView>}
      </>
    }

    //const isInProfilePage = window.location.pathname === '/identity/profile'
    //return <NavItem
    //  icon={<Avatar icon="user" size='small' shape="circle" src={avatarSrc} />}
    //  title={displayName} subMenu={
    //    <Menu onClick={this.handleClick} >
    //      <MenuItem key="user">
    //        <Icon type="user" />
    //        {!isInProfilePage && <Link to='/identity/profile'>{t('Your Profile')}</Link>}
    //        {isInProfilePage && <div style={{ display: 'inline-block' }}>{t('Your Profile')}</div>}
    //      </MenuItem>
    //      {this.props.ensureCompanySelection && <MenuItem key="changeCompany">
    //        <Icon type="book" />
    //        <Link to='/home/companies/select'>{t('Change company')}</Link>
    //      </MenuItem>}
    //      <MenuItem key="logout">
    //        <Icon type="logout" />
    //        <span>{t('Close session')}</span>
    //      </MenuItem>
    //    </Menu>
    //  }>
    //</NavItem>
  //}
}
export default withTranslation()(withIdentity(LoginBox));


